import { render, staticRenderFns } from "./empresasView.vue?vue&type=template&id=3f2a4fc0&"
import script from "./empresasView.vue?vue&type=script&lang=js&"
export * from "./empresasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports